import * as actions from '../../actions/actions'
import update from "immutability-helper";

const initialState = {
  plickDetail: {
    id:'',
    fileId:'',
    transactionId: '',
    senderId: '',
    senderFirstname: '',
    senderLastname: '',
    senderIsCompany: false,
    senderCompany: '',
    senderDevice: '',
    senderAccount: '',
    senderLanguagePreferences: '',
    senderExtraInfo:'',
    receiverName: '',
    receiverDevice: '',
    receiverIban: '',
    receiverIbanFromBank: false,
    idBank: '',
    activationDate: '',
    amount: 0,
    amountString:'',
    causal: '',
    notes: '',
    pin: '',
    pinType: '',
    idLogo: '',
    receiverLanguagePreferences: '',
    correctPlick: false,
    plickIdFromPortal: '',
    plickType: '',
    receiverType: '',
    bankCro: '',
    bankExecutionDate: '',
    currencyDate: '',
    transferStatus: '',
    validationErrorsList:[]
  },
  error: ''
}

export default function plickDetail(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_PLICK_DETAIL_SUCCESS:
      return fetchPlickDetailSuccess(state, action)
    case actions.FETCH_PLICK_DETAIL_FAILURE:
      return fetchPlickDetailFailure(state, action)
    case actions.DETAIL_PLICK_CLEAN:
      return detailPlickClean(state, action)

    case actions.PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE:
      return plickDetailFirstNameChange(state, action)
    case actions.PLICK_DETAIL_LAST_NAME_FIELD_CHANGE:
      return plickDetailLastNameChange(state, action)
    case actions.PLICK_DETAIL_CAUSAL_FIELD_CHANGE:
      return plickDetailCausalChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE:
      return plickDetailReceiverNameChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE:
      return plickDetailReceiverDeviceChange(state, action)
    case actions.PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE:
      return plickDetailActivationDateChange(state, action)
    case actions.PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE:
      return plickDetailSenderCompanyChange(state, action)
    case actions.PLICK_DETAIL_ID_BANK_FIELD_CHANGE:
      return plickDetailIdBankChange(state, action)
    case actions.PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE:
      return plickDetailSenderDeviceChange(state, action)
    case actions.PLICK_DETAIL_ID_LOGO_FIELD_CHANGE:
      return plickDetailIdLogoChange(state, action)
    case actions.PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE:
      return plickDetailTransactionIdChange(state, action)
    case actions.PLICK_DETAIL_SENDER_ID_FIELD_CHANGE:
      return plickDetailSenderIdChange(state, action)
    case actions.PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE:
      return plickDetailSenderFirstnameChange(state, action)
    case actions.PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE:
      return plickDetailSenderLastnameChange(state, action)
    case actions.PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE:
      return plickDetailSenderIsCompanyChange(state, action)
    case actions.PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE:
      return plickDetailSenderAccountChange(state, action)
    case actions.PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE:
      return plickDetailSenderLanguagePreferencesChange(state, action)
    case actions.PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE:
      return plickDetailSenderExtraInfoChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE:
      return plickDetailReceiverIbanChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE:
      return plickDetailReceiverIbanFromBankChange(state, action)
    case actions.PLICK_DETAIL_AMOUNT_FIELD_CHANGE:
      return plickDetailAmountChange(state, action)
    case actions.PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE:
      return plickDetailAmountStringChange(state, action)
    case actions.PLICK_DETAIL_NOTES_FIELD_CHANGE:
      return plickDetailNotesChange(state, action)
    case actions.PLICK_DETAIL_PIN_FIELD_CHANGE:
      return plickDetailPinChange(state, action)
    case actions.PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE:
      return plickDetailPinTypeChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE:
      return plickDetailReceiverLanguagePreferencesChange(state, action)
    case actions.PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE:
      return plickDetailCorrectPlickChange(state, action)
    case actions.PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE:
      return plickDetailPlickIdFromPortalChange(state, action)
    case actions.PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE:
      return plickDetailPlickTypeChange(state, action)
    case actions.PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE:
      return plickDetailReceiverTypeChange(state, action)
    case actions.PLICK_DETAIL_BANK_CRO_FIELD_CHANGE:
      return plickDetailBankCroChange(state, action)
    case actions.PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE:
      return plickDetailBankExecutionDateChange(state, action)
    case actions.PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE:
      return plickDetailCurrencyDateChange(state, action)
    case actions.PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE:
      return plickDetailTransferStatusChange(state, action)
    default:
      return state
  }
}

const fetchPlickDetailSuccess = (state, action) => {
  return {
    ...state,
    plickDetail: action.value,
    error: null
  }
}

const fetchPlickDetailFailure = (state, action) => {
  return {
    ...state,
    plickDetail: null,
    error: action.error
  }
}

const detailPlickClean = (state, action) => {
  return initialState;
}

const plickDetailFirstNameChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderFirstname: {$set: action.value}}}
  )
}

const plickDetailLastNameChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderLastname: {$set: action.value}}}
  )
}
const plickDetailAmountChange = (state, action) => {
  return update(
      state,
      {plickDetail: {amount: {$set: action.value}}}
  )
}

const plickDetailCausalChange = (state, action) => {
  return update(
      state,
      {plickDetail: {causal: {$set: action.value}}}
  )
}
const plickDetailReceiverNameChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverName: {$set: action.value}}}
  )
}
const plickDetailReceiverDeviceChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverDevice: {$set: action.value}}}
  )
}
const plickDetailActivationDateChange = (state, action) => {
  return update(
      state,
      {plickDetail: {activationDate: {$set: action.value}}}
  )
}
const plickDetailSenderCompanyChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderCompany: {$set: action.value}}}
  )
}
const plickDetailSenderDeviceChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderDevice: {$set: action.value}}}
  )
}
const plickDetailIdLogoChange = (state, action) => {
  return update(
      state,
      {plickDetail: {idLogo: {$set: action.value}}}
  )
}

const plickDetailIdBankChange = (state, action) => {
  return update(
      state,
      {plickDetail: {idBank: {$set: action.value}}}
  )
}

const plickDetailTransactionIdChange = (state, action) => {
  return update(
      state,
      {plickDetail: {transactionId: {$set: action.value}}}
  )
}

const plickDetailSenderIdChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderId: {$set: action.value}}}
  )
}

const plickDetailSenderFirstnameChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderFirstname: {$set: action.value}}}
  )
}

const plickDetailSenderLastnameChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderLastname: {$set: action.value}}}
  )
}

const plickDetailSenderIsCompanyChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderIsCompany: {$set: action.value}}}
  )
}

const plickDetailSenderAccountChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderAccount: {$set: action.value}}}
  )
}

const plickDetailSenderLanguagePreferencesChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderLanguagePreferences: {$set: action.value}}}
  )
}

const plickDetailSenderExtraInfoChange = (state, action) => {
  return update(
      state,
      {plickDetail: {senderExtraInfo: {$set: action.value}}}
  )
}

const plickDetailReceiverIbanChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverIban: {$set: action.value}}}
  )
}

const plickDetailReceiverIbanFromBankChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverIbanFromBank: {$set: action.value}}}
  )
}

const plickDetailAmountStringChange = (state, action) => {
  return update(
      state,
      {plickDetail: {amountString: {$set: action.value}}}
  )
}

const plickDetailNotesChange = (state, action) => {
  return update(
      state,
      {plickDetail: {notes: {$set: action.value}}}
  )
}

const plickDetailPinChange = (state, action) => {
  return update(
      state,
      {plickDetail: {pin: {$set: action.value}}}
  )
}

const plickDetailPinTypeChange = (state, action) => {
  return update(
      state,
      {plickDetail: {pinType: {$set: action.value}}}
  )
}

const plickDetailReceiverLanguagePreferencesChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverLanguagePreferences: {$set: action.value}}}
  )
}

const plickDetailCorrectPlickChange = (state, action) => {
  return update(
      state,
      {plickDetail: {correctPlick: {$set: action.value}}}
  )
}

const plickDetailPlickIdFromPortalChange = (state, action) => {
  return update(
      state,
      {plickDetail: {plickIdFromPortal: {$set: action.value}}}
  )
}

const plickDetailPlickTypeChange = (state, action) => {
  return update(
      state,
      {plickDetail: {plickType: {$set: action.value}}}
  )
}

const plickDetailReceiverTypeChange = (state, action) => {
  return update(
      state,
      {plickDetail: {receiverType: {$set: action.value}}}
  )
}

const plickDetailBankCroChange = (state, action) => {
  return update(
      state,
      {plickDetail: {bankCro: {$set: action.value}}}
  )
}

const plickDetailBankExecutionDateChange = (state, action) => {
  return update(
      state,
      {plickDetail: {bankExecutionDate: {$set: action.value}}}
  )
}

const plickDetailCurrencyDateChange = (state, action) => {
  return update(
      state,
      {plickDetail: {currencyDate: {$set: action.value}}}
  )
}

const plickDetailTransferStatusChange = (state, action) => {
  return update(
      state,
      {plickDetail: {transferStatus: {$set: action.value}}}
  )
}